'use client';
import React from 'react';
import { RenderCellProps } from 'react-data-grid';
import { getDataCellMetadata } from './lib';

import classNames from 'classnames';
import * as DataCellRenderer from '../FieldRenderers/DataCellRenderer';

import { ColumnWithDType } from '../types';
import { DIFF_STATUS_FIELD_NAME } from '@/components/DataFrame/consts';

const getRowStatusClass = (row: any) => {
  const rowAction = row[DIFF_STATUS_FIELD_NAME];
  return classNames({
    'row-added': rowAction === 'added',
    'row-removed': rowAction === 'removed' || rowAction === 'deleted',
    'row-modified': rowAction === 'modified',
    'row-dirty': rowAction === 'dirty',
  });
};

const getCellStatusClass = (props: RenderCellProps<any>) => {
  const field = props.column as ColumnWithDType;
  const { isCompare, isChanged, isAdded, isRemoved } = getDataCellMetadata(props);
  return classNames({
    'text-cell-compare': isCompare,
    'text-cell-compare-unchanged': !isChanged,
    'text-cell-compare-added': isAdded,
    'text-cell-compare-removed': isRemoved,
    'text-cell-editable': field.editable === true,
    'text-cell-not-editable': field.editable === false,
  });
};

const CellRenderComponents: any = {
  diff_status: DataCellRenderer.DiffStatus,
  image: DataCellRenderer.Image,
  link: DataCellRenderer.Link,
  list: DataCellRenderer.List,
  struct: DataCellRenderer.Struct,
  bool: DataCellRenderer.Boolean,
  float: DataCellRenderer.Number,
  int: DataCellRenderer.Number,
  default: DataCellRenderer.String,
};

const DataCell: React.FC<RenderCellProps<any>> = (props) => {
  const field = props.column as ColumnWithDType;
  const { renderAs, value } = getDataCellMetadata(props);

  const rowStatusClass = getRowStatusClass(props.row);
  const cellStatusClass = getCellStatusClass(props);
  const cellClass = classNames('text-cell', rowStatusClass, cellStatusClass);

  const CellRenderComponent = CellRenderComponents[renderAs] || CellRenderComponents.default;
  return (
    <CellRenderComponent
      className={cellClass}
      // onClick={() => console.log('cell props', props)}
      field={field}
      value={value}
      renderAs={renderAs}
    />
  );
};

export default DataCell;
